import type { PlanCheckoutResponse } from './api';

export type PlanCheckoutOutcome =
  | { kind: 'redirect'; checkoutUrl: string }
  | { kind: 'manual_required' }
  | { kind: 'completed' }
  | { kind: 'select_plan'; status: string }
  | { kind: 'pending'; status: string }
  | { kind: 'terminal'; status: string }
  | { kind: 'missing_url'; status: string };

const TERMINAL_STATUSES = new Set(['expired', 'failed', 'canceled', 'cancelled']);
const PENDING_STATUSES = new Set(['processing', 'accepted', 'awaiting_payment', 'payment_pending']);

export const resolvePlanCheckoutOutcome = (checkout: PlanCheckoutResponse): PlanCheckoutOutcome => {
  const status = (checkout.checkout_status || '').trim().toLowerCase();
  const checkoutUrl = (checkout.checkout_url || '').trim();

  if (status === 'manual_required') {
    return { kind: 'manual_required' };
  }
  if (!checkout.checkout_required || status === 'managed_subscription' || status === 'not_required') {
    return { kind: 'select_plan', status: status || 'not_required' };
  }
  if (status === 'completed') {
    return { kind: 'completed' };
  }
  if (TERMINAL_STATUSES.has(status)) {
    return { kind: 'terminal', status };
  }
  if (checkoutUrl) {
    return { kind: 'redirect', checkoutUrl };
  }
  if (PENDING_STATUSES.has(status)) {
    return { kind: 'pending', status };
  }
  return { kind: 'missing_url', status: status || 'unknown' };
};
